import VSelectCard from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCard', VSelectCard),
};
